import React, { useEffect, useState } from "react";
import styled from "styled-components";
import SafeHtmlSpan from "../ui/SafeHtmlSpan";
import { SvgBackground } from "../ui/SvgBackground";

const MobileBreakPoints = ["base", "mobile"];

const Container = styled.div`
  position: relative;
  overflow: hidden;
  display: flex;
  cursor: pointer;
  user-select: none;
  ${(props) =>
    props.theme.apply("default", (breakpoint: string) => {
      return `
          height: ${props.theme.spacePx(breakpoint, MobileBreakPoints.includes(breakpoint) ? 6 : 7)};          
        `;
    })}

  @media (any-pointer: fine) {
    &:hover {
      label {
        background-color: #000;
        color: #fff;

        & div {
          filter: invert(100%);
        }
      }
    }
  }

  .tabbed &:focus-within {
    outline-width: 3px;
    outline-color: var(--ikon-focus-color, #00f);
    outline-offset: 3px;
    outline-style: solid;
  }
`;

const Input = styled.input`
  position: absolute;
  top: -30px;
  height: -30px;

  &:checked + label {
    background-color: #000;
    color: #fff;
  }
`;

const Label = styled.label`
  position: relative;
  cursor: pointer;
  display: flex;
  align-items: center;
  transition: color 0.3s, background-color 0.3s;
  height: 100%;
  border: 1px solid #000;
  
  & span {
    display: block;
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  ${(props) =>
    props.theme.apply("default", (breakpoint: string) => {
      return `
        ${props.theme.textStyle(breakpoint, `h4Heading`)};
        column-gap: ${props.theme.spacePx(breakpoint, 10)};
        padding: 0 ${props.theme.spacePx(breakpoint, 10)};

        & span {
          padding-top: ${(
            1 + props.theme.fontValign(breakpoint, "h4Heading")
          ).toFixed(2)}px;
        }
      `;
    })}
`;

const Check = styled.div<{ isChecked: boolean }>`
  position: relative;
  transition: color 0.3s, filter 0.3s;
  filter: ${({ isChecked }) => (isChecked ? "invert(100%)" : "invert(0%)")};
  ${(props) =>
    props.theme.apply("default", (breakpoint: string) => {
      return `
        width: ${props.theme.spacePx(breakpoint, 9)};
        height: ${props.theme.spacePx(breakpoint, 9)}; 
        overflow: hidden;       
      `;
    })}
`;

export const FilterCategory = ({
  label,
  value,
  name,
  id,
  defaultChecked,
  onChange,
  onClick,
}: {
  label: string;
  defaultChecked?: boolean;
  name: string;
  value: string | number;
  id: string;
  onChange?: Function;
  onClick?: Function;
}) => {
  const [isChecked, setIsChecked] = useState<boolean>(!!defaultChecked);

  useEffect(() => {
    setIsChecked(!!defaultChecked);
  }, [defaultChecked]);

  return (
    <Container>
      <Input
        type="checkbox"
        id={id}
        name={name}
        value={value}
        checked={isChecked}
        onChange={(event) => {
          setIsChecked(!isChecked);
          if (typeof onChange === "function") onChange.call(null, event);
        }}
        onClick={() => {
          if (typeof onClick === "function") onClick.call(null);
        }}
      />
      <Label htmlFor={id}>
        <SafeHtmlSpan html={label} />
        <Check isChecked={isChecked}>
          <SvgBackground
            className="svg close"
            type={isChecked ? "close" : "plus"}
            width="100%"
            height="100%"
          />
        </Check>
      </Label>
    </Container>
  );
};
